import { type ReorderMachineGuard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfGroupOrderReorderStartedFromLocationSearch: ReorderMachineGuard = ({
  context,
}) => {
  return context.groupOrderReorderRequest?.originStep === 'locationSearch';
};
